export class DeviceToken {
  uuid: string;
  token?: string;
  info?: string;

  constructor(uuid: string, notificationToken?: string, info?: string) {
    this.uuid = uuid;
    this.token = notificationToken;
    this.info = info;
  }
}
